import { useTrackingParameters } from 'remote-com-shared/domains/shared/trackingParameters';

export function GlobalHooks() {
  useTrackingParameters();
  return null;
}
